/*
 * @Author: your name
 * @Date: 2020-06-13 17:25:13
 * @LastEditTime: 2020-06-13 17:36:04
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /x-project-app/src/pages/app-engine/app-engine-page/page-button-type.js
 */
const PageButtonTypeMap = {
  REFRESH: {
    icon: 'refresh-icon',
    executeFunction: 'doRefresh'
  },
  SPREAD: {
    icon: 'spread-icon',
    executeFunction: 'doSpread'
  },
  ADVANCE_SEARCH: {
    icon: 'advance-search-icon'
  },
  EXPORT: {
    icon: 'export-icon',
    executeFunction: 'doExport'
  },
  OP_SHARE: {
    icon: 'op-share-icon',
    executeFunction: 'doShare'
  }
}

export default PageButtonTypeMap
